module.exports = __webpack_public_path__ + "img/Cloudwise.fee40cee.jpg";